import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { IVolunteerShift } from './models';
import { invalidateVolunteerShifts } from './useVolunteerShifts';

export const useArchiveVolunteerShiftMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: IVolunteerShift) => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({
			shiftId,
			impersonationContext,
		}: {
			shiftId: string;
			activityId: string;
			impersonationContext?: Api.IImpersonationContext;
		}) =>
			userSession.webServiceHelper.callAsync<IVolunteerShift>(
				Api.ImpersonationBroker.composeApiUrl({ impersonationContext, urlPath: `volunteering/shifts/${shiftId}` }),
				'DELETE'
			),
		onSuccess: (data, variables) => {
			invalidateVolunteerShifts(variables.activityId);
			onSuccess?.(data);
		},
		onError,
	});
};
